module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start view"
  }, [(_vm.$store.state.overlay !== null) ? _c('overlay') : _vm._e(), _vm._v(" "), _c('menu-desktop'), _vm._v(" "), _c('menu-mobile'), _vm._v(" "), _c('splash'), _vm._v(" "), _c('products'), _vm._v(" "), _c('feed'), _vm._v(" "), _c('footern')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-999f856a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Start.vue
// module id = 232
// module chunks = 1